import React, { useEffect, useRef, useState } from 'react';
import SearchBar from '../searchBar/SearchBar';
import Profilepic from '../../assets/images/profilePic.jpg';
import styles from './TopBar.module.css';
import { logOut } from '../../features/auth/services/auth';
import { useTheme } from '../../middleware/ThemeContext';
import MenuIcon from '../../assets/icons/MenuIcon';
import LangIcon from '../../assets/icons/LangIcon';
import SyncIcon from '../../assets/icons/SyncIcon';
import SettingsIcon from '../../assets/icons/SettingsIcon';
import BellIcon from '../../assets/icons/BellIcon';
import ProfileDropdown from './ProfileDropdown';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import { useGetLoginUserQuery } from '../../api/amsApiSlice';
import { Skeleton } from '@mui/material';

interface TopBarProps {
    onMenuToggle: () => void;
}
interface userData {
    accountType: number;
    title: string;
    firstName: string;
    lastName: string;
    email: string;
    secondaryEmail: string;
    isOwner: boolean;
    companyId: number;
    statusId: number;
    company: {
    id: number;
    name: string;
    companyEmail: string;
    statusId: number;
    };
    signedUrl: string;
}
const TopBar: React.FC<TopBarProps> = ({ onMenuToggle }) => {
    const { theme } = useTheme();
    const [userData, setUserData] = useState<userData>();
    const [userProfile, setUserProfile] = useState(false);
    const triggerRef = useRef<HTMLDivElement>(null);
    const {data, isLoading} = useGetLoginUserQuery({});

    useEffect(() => {
        if(data) {
            setUserData(data.data);
        }
    }, [data]);
    
    useOnClickOutside(triggerRef as React.RefObject<HTMLElement>, () => setUserProfile(false));

    return (
        <div className={styles.topBarContainer} style={{ backgroundColor: theme.colors.topBarsColorBG, borderColor: theme.colors.topBarsColorBorder }}>
            <button className={styles.menuButton}
                onClick={onMenuToggle}
                aria-label="Toggle menu">
                <MenuIcon color={theme.colors.topBarsColorText} />
            </button>

            <SearchBar />
            <div className={styles.rightSection}>
                {/* <button className={styles.iconButton} aria-label="Change language">
                    <LangIcon color={theme.colors.topBarsColorText} />
                </button>
                <button className={styles.iconButton} aria-label="Sync">
                    <SyncIcon color={theme.colors.topBarsColorText} />
                </button>
                <button className={styles.iconButton} aria-label="Settings">
                    <SettingsIcon color={theme.colors.topBarsColorText} size={18} />
                </button>*/}
                <button className={styles.iconButton} aria-label="Notifications">
                    <BellIcon color={theme.colors.topBarsColorText} />
                </button>

                <div onClick={() => !isLoading && userData && setUserProfile(prev => !prev)}>
                    <img src={userData?.signedUrl || Profilepic} alt="Profile" className={styles.profileImage} />
                </div>
                {userProfile && userData && 
                    <ProfileDropdown ref={triggerRef} user={userData} />
                }

            </div>
        </div>
    );
};

export default TopBar;
